import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
    selector: 'scaffold-icon',
    templateUrl: './icon.component.html',
    styles: [],
    standalone: false
})
export class IconComponent extends BaseScaffoldComponent implements OnInit {
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }
  public destroy$: Subject<boolean> = new Subject<boolean>();

  LearningComponent;
  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });
  }

  OnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  toURL(url: any): any {
    if (url) {
      if (url.match(/^https*:\/\//)) {
        return url;
      } else {
        return 'https://' + url;
      }
    }

    return null;
  }

  getIcon(icon, index) {
    const i = icon.split(/\s/);
    if (i.length > 1) {
      if (index === 0) {
        return i[0];
      }
      if (index === 1) {
        return i[1].replace(/fa-/, '');
      }
    } else {
      if (index === 0) {
        return 'fas';
      }
      if (index === 1) {
        return i[0].replace(/fa-/, '');
      }
    }
  }
}
